import { render } from "./recut-new-dhanush.vue?vue&type=template&id=98d23578&scoped=true"
import script from "./recut-new-dhanush.vue?vue&type=script&lang=js"
export * from "./recut-new-dhanush.vue?vue&type=script&lang=js"

import "./recut-new-dhanush.vue?vue&type=style&index=0&id=98d23578&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d23578"]])

export default __exports__